<template>
  <div class="midFilter">
    <div v-if="!filterShow">
      <el-dropdown
        trigger="click"
        @command="handleFilterCommand"
        placement="bottom"
      >
        <el-button type="text">
          <el-image
            :src="filterIcon"
            style="width: 16px; height: 16px; margin-right: 5px; vertical-align: middle"
          ></el-image>
          <span style="color: #999"> 筛选 </span>
        </el-button>
        <el-dropdown-menu
          slot="dropdown"
          style="width: 460px"
          ref="filterDrop"
        >
          <div class="cusFilter">
            <div
              class="cusFilterList"
              v-if="initData"
            >
              <div
                class="cusFilterItem"
                v-for="(filterObj, index) in cusFilterList"
                :key="index"
              >
                <el-row
                  align="middle"
                  :gutter="5"
                >
                  <el-col :span="6">
                    <el-select
                      size="mini"
                      v-model="filterObj.field"
                      popper-class="dropselect"
                      @change="fieldChange(cusFilterList, filterObj, index)"
                    >
                      <el-option
                        v-for="filterItem in initData.FilterFields"
                        :key="filterItem.keyName"
                        :label="filterItem.name"
                        :value="filterItem.keyName"
                        :disabled="
                          cannotChangeField(cusFilterList, filterItem) ||
                          (filterItem.keyName === 'approval_status' &&
                            (level === 'campaign' || !initData.ApprovalStatus?.length))
                        "
                      >
                        <span @click="showFilterDrop">
                          {{ filterItem.name }}
                        </span>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <el-select
                      size="mini"
                      v-model="filterObj.operator"
                      v-if="filterObj.field"
                      popper-class="dropselect"
                      :disabled="filteringList(filterObj).length == 1"
                    >
                      <el-option
                        v-for="operators in filteringList(filterObj)"
                        :key="operators.key"
                        :label="operators.desc"
                        :value="operators.key"
                      >
                        <span @click="showFilterDrop">{{ operators.desc }}</span>
                      </el-option>
                    </el-select>
                    <el-select
                      size="mini"
                      v-model="filterObj.operator"
                      disabled
                      popper-class="dropselect"
                      v-else
                    >
                    </el-select>
                  </el-col>
                  <el-col :span="11">
                    <el-select
                      size="mini"
                      v-if="filterObj.field == 'type'"
                      v-model="filterObj.value"
                      popper-class="dropselect"
                    >
                      <el-option
                        v-for="filterItem in initData.AdvertisingChannelType"
                        :key="filterItem.key"
                        :label="filterItem.desc"
                        :value="filterItem.key"
                      >
                        <span @click="showFilterDrop">
                          {{ filterItem.desc }}
                        </span>
                      </el-option>
                    </el-select>
                    <el-select
                      size="mini"
                      v-if="filterObj.field == 'status'"
                      v-model="filterObj.value1"
                      multiple
                      popper-class="dropselect"
                    >
                      <el-option
                        v-for="filterItem in initData.FilteringStatus"
                        :key="filterItem.key"
                        :label="filterItem.desc"
                        :value="filterItem.key"
                      >
                        <span @click="showFilterDrop">
                          {{ filterItem.desc }}
                        </span>
                      </el-option>
                    </el-select>
                    <!-- 审批状态单选下拉框 -->
                    <el-select
                      size="mini"
                      v-if="filterObj.field == 'approval_status'"
                      v-model="filterObj.value"
                      popper-class="dropselect"
                    >
                      <el-option
                        v-for="filterItem in initData.ApprovalStatus"
                        :key="filterItem.key"
                        :label="filterItem.desc"
                        :value="filterItem.key"
                      >
                        <span @click="showFilterDrop">
                          {{ filterItem.desc }}
                        </span>
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-if="
                        filterObj.field != 'status' && filterObj.field != 'type' && filterObj.field != 'approval_status'
                      "
                      v-model="filterObj.value"
                    ></el-input>
                  </el-col>
                  <el-col :span="2">
                    <i
                      class="el-icon-close"
                      v-if="cusFilterList.length > 1"
                      @click="deleFilterObj(index)"
                      style="margin-top: 5px"
                    ></i>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="btnGroup">
              <el-button
                type="primary"
                size="mini"
                @click="saveFilterSearch"
              >
                确定
              </el-button>
              <el-button
                size="mini"
                @click="addFilter"
              >
                添加
              </el-button>
            </div>
          </div>
          <el-dropdown-item
            disabled
            divided
            style="font-size: 12px"
          >
            你的筛选组合
          </el-dropdown-item>
          <el-dropdown-item
            v-for="(filter, index) in filterList"
            :key="filter.id + index"
            :command="filter"
            :class="[filterId && filterId == filter.id ? 'active' : '']"
          >
            <div class="columnName">
              <span>{{ filter.name }}</span>
              <div>
                <p>
                  <i
                    class="el-icon-delete"
                    v-if="filter.id"
                    @click.stop="$emit('delete-filter-group', filter.id)"
                  ></i>
                </p>
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      class="filterWrap"
      v-show="filterShow"
    >
      <el-image
        :src="filterIcon"
        style="width: 14px; height: 14px"
      ></el-image>

      <div
        class="paramsFilters"
        v-if="params.filtering && params.filtering.length"
      >
        <el-tag
          :key="i"
          v-for="(tags, i) in params.filtering"
          closable
          :disable-transitions="false"
          @close="deleFilterTag(tags, i)"
          size="mini"
          effect="dark"
          style="border-radius: 10px; font-size: 12px"
        >
          <div>
            <el-dropdown
              trigger="click"
              placement="bottom"
            >
              <span
                style="color: #fff"
                v-if="initData.FilterFields"
                >{{ formatFilterNameTable(tags) | showName }}</span
              >
              <el-dropdown-menu slot="dropdown">
                <el-radio-group
                  v-model="tags.field"
                  @change="fieldChange(params.filtering, tags, i)"
                >
                  <p
                    v-for="filterItem in initData.FilterFields"
                    :key="filterItem.keyName"
                    style="padding: 10px"
                  >
                    <el-radio
                      :label="filterItem.keyName"
                      :disabled="
                        cannotChangeField(params.filtering, filterItem) ||
                        (filterItem.keyName === 'approval_status' &&
                          (level === 'campaign' || !initData.ApprovalStatus?.length))
                      "
                    >
                      {{ filterItem.name }}
                    </el-radio>
                  </p>
                </el-radio-group>
              </el-dropdown-menu>
            </el-dropdown>
            <span style="margin: 0 5px">
              <span v-if="tags.field == 'status'">
                {{ operatorName(tags) || '包含' }}
              </span>
              <el-dropdown
                trigger="click"
                placement="bottom"
                v-else
              >
                <span style="color: #fff">
                  {{ operatorName(tags) || '请选择' }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-radio-group
                    v-model="tags.operator"
                    @change="$emit('operator-change')"
                  >
                    <p
                      v-for="filterItem in showFiltering(tags)"
                      :key="filterItem.key"
                      style="padding: 10px"
                    >
                      <el-radio :label="filterItem.key">
                        {{ filterItem.desc }}
                      </el-radio>
                    </p>
                  </el-radio-group>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <span>
              <el-dropdown
                trigger="click"
                placement="bottom"
                v-if="tags.field == 'status'"
              >
                <span style="color: #fff">
                  {{ valueName(tags) || '请选择' }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-checkbox-group
                    v-model="tags.value1"
                    @change="$emit('value-change')"
                  >
                    <p
                      v-for="(checkbox, index) in initData[
                        tags.field == 'status' ? 'FilteringStatus' : 'AdvertisingChannelType'
                      ]"
                      :key="index"
                      style="padding: 10px"
                    >
                      <el-checkbox :label="checkbox.key">
                        {{ checkbox.desc }}
                      </el-checkbox>
                    </p>
                  </el-checkbox-group>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown
                trigger="click"
                placement="bottom"
                v-if="tags.field == 'type'"
              >
                <span style="color: #fff">
                  {{ valueName(tags) || '请选择' }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-radio-group
                    v-model="tags.value"
                    @change="$emit('value-change')"
                  >
                    <p
                      v-for="(checkbox, index) in initData['AdvertisingChannelType']"
                      :key="index"
                      style="padding: 10px"
                    >
                      <el-radio :label="checkbox.key">
                        {{ checkbox.desc }}
                      </el-radio>
                    </p>
                  </el-radio-group>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 审批状态单选下拉框 -->
              <el-dropdown
                trigger="click"
                placement="bottom"
                v-if="tags.field == 'approval_status'"
              >
                <span style="color: #fff">
                  {{ valueName(tags) || '请选择' }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-radio-group
                    v-model="tags.value"
                    @change="$emit('value-change')"
                  >
                    <p
                      v-for="(item, index) in initData['ApprovalStatus']"
                      :key="index"
                      style="padding: 10px"
                    >
                      <el-radio :label="item.key">
                        {{ item.desc }}
                      </el-radio>
                    </p>
                  </el-radio-group>
                </el-dropdown-menu>
              </el-dropdown>
              <span v-if="tags.field != 'status' && tags.field != 'type' && tags.field != 'approval_status'">
                <el-input
                  v-model="tags.value"
                  class="tagInput"
                  @change="$emit('value-change')"
                ></el-input>
              </span>
            </span>
          </div>
        </el-tag>
        <el-tag
          size="mini"
          style="border-radius: 10px; font-size: 12px; border: 1px dashed #409eff; cursor: pointer"
          @click="addTag"
        >
          <i class="el-icon-plus"></i>
          <span>添加筛选项</span>
        </el-tag>
      </div>
      <div class="rightIcon">
        <i
          class="el-icon-finished"
          @click="$emit('save-filter-show', true)"
        ></i>
        <i
          class="el-icon-circle-close"
          @click="closeMyFilter"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterPanel',
  props: {
    initData: Object,
    params: Object,
    filterShow: Boolean,
    cusFilterList: Array,
    filterList: Array,
    filterId: [String, Number],
    filterIcon: String,
    // 当前广告层级，用于控制 approval_status 筛选选项的可用性
    level: {
      type: String,
      default: 'campaign',
    },
  },
  filters: {
    showName(item) {
      return item ? (item['name'] ? item['name'] : '请选择') : '请选择';
    },
  },
  computed: {
    filteringList() {
      return (item) => {
        if (!this.initData || !this.initData.FilterFields) return [];
        const filterObj = this.initData.FilterFields.find((v) => v.keyName == item.field);
        return filterObj && filterObj.filtering ? filterObj.filtering : [];
      };
    },
  },
  methods: {
    handleFilterCommand(v) {
      this.$emit('filter-command', v);
    },
    fieldChange(list, v, i) {
      if (!this.initData || !this.initData.FilterFields) return;
      let obj = JSON.parse(JSON.stringify(v));
      const filtering = this.initData.FilterFields.find((item) => item.keyName == v.field);
      if (filtering && filtering.filtering && filtering.filtering.length == 1) {
        obj.operator = filtering.filtering[0].key;
      } else {
        obj.operator = '';
      }
      obj.value = '';
      obj.value1 = [];
      this.$emit('field-change', { list, obj, index: i });
    },
    deleFilterObj(i) {
      this.$emit('delete-filter-obj', i);
    },
    showFilterDrop() {
      this.$nextTick((res) => {
        this.$refs.filterDrop.dropdown.show();
      });
    },
    addFilter() {
      let cusFilterList = this.cusFilterList;
      let flag = true;
      cusFilterList.map((item) => {
        if (!item.field || !item.operator || (!item.value && !item.value1.length)) {
          this.$message({
            type: 'warning',
            message: '请填写完整的信息',
          });
          flag = false;
        }
      });
      if (flag) {
        this.$emit('add-filter-item');
      }
      return flag;
    },
    saveFilterSearch() {
      if (this.addFilter()) {
        this.$emit('save-filter-search');
      }
    },
    cannotChangeField(list, filterItem) {
      return !!list.find((v) => v.field == filterItem.keyName);
    },
    deleFilterTag(tag, i) {
      this.$emit('delete-filter-tag', { tag, index: i });
    },
    addTag() {
      this.$emit('add-tag');
    },
    closeMyFilter() {
      this.$emit('close-my-filter');
    },
    formatFilterNameTable(tags) {
      if (!this.initData || !this.initData.FilterFields || this.initData.FilterFields.length == 0) return {};
      let arr = this.initData.FilterFields.filter((v) => v.keyName == tags.field) || [];
      return arr && arr.length ? arr[0] : {};
    },
    operatorName(tag) {
      if (!this.initData || !this.initData.FilterFields) return '请选择';
      const v = this.initData.FilterFields.find((v) => v.keyName == tag.field);
      if (v && v.filtering) {
        const item = v.filtering.find((m) => m.key == tag.operator);
        return item ? item.desc : '';
      }
      return '请选择';
    },
    showFiltering(tag) {
      if (!this.initData || !this.initData.FilterFields) return [];
      let list = this.initData.FilterFields.find((v) => v.keyName == tag.field);
      return list && list.filtering ? list.filtering : [];
    },
    valueName(tag) {
      if (!this.initData) return '请选择';
      let list = [];
      tag.value1 = tag.value1 || tag.value || [];
      if (Array.isArray(tag.value1)) {
        tag.value1.forEach((item) => {
          if (this.initData.FilteringStatus) {
            const found = this.initData.FilteringStatus.find((v) => v.key === item);
            if (found) list.push(found.desc);
          }
        });
      }
      if (tag.field == 'type') {
        const found = this.initData.AdvertisingChannelType.find((v) => v.key === tag.value);
        if (found) list.push(found.desc);
      } else if (tag.field == 'approval_status') {
        // 审批状态中文描述
        const found = this.initData.ApprovalStatus?.find((v) => v.key === tag.value);
        if (found) list.push(found.desc);
      } else if (tag.value) {
        list.push(tag.value);
      }
      return list.length ? list.join(',') : '请选择';
    },
  },
};
</script>
<style lang="scss" scoped>
.filterWrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ecf5ff;

  .el-image {
    flex: 14px 0 0;
    margin-left: 5px;
  }

  .paramsFilters {
    flex: 1;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .el-tag {
      margin: 3px;
      display: flex;
      align-items: center;

      .checkbox-group {
        padding: 0 10px;

        .el-checkbox {
          display: block;
        }
      }
    }
  }

  .rightIcon {
    flex: 40px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      font-size: 15px;
      font-weight: bold;
      margin: 0 5px;
      cursor: pointer;
      color: #666;
    }
  }
}
</style>
